// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"l8-z"};